import {
  IBasePagingRes,
  IBaseResponseModel,
} from "../../models/common/models.type";
import api from "../remote/baseApi";
import ApiEndpoints from "../remote/apiEndpoints";
import { envConfig } from "../../config/env.config";
import { EContentResponse, ESeoResponse } from "../../models/seo";
import { EBlogResponse, IBlogGetPage } from "../../models/blog";

const API = ApiEndpoints.BLOGFOOTER;
const APISITEMAP = ApiEndpoints.SiteMap;

const baseURL = envConfig.API_ENDPOINT;

const userGetPage = (
  data: IBlogGetPage,
): Promise<IBasePagingRes<EBlogResponse>> => {
  return api.get(baseURL, API.UserGetPage.url, {
    params: data,
  });
};

const adminGetPage = (
  data: IBlogGetPage,
): Promise<IBasePagingRes<EBlogResponse>> => {
  return api.get(baseURL, API.AdminGetPage.url, {
    params: data,
  });
};

const getSingle = async (
  id: string,
): Promise<IBaseResponseModel<EBlogResponse>> => {
  return api.get(baseURL, API.GetSingle.url + "?id=" + id);
  //return res;
};

const getSingleBySlug = async (
  slug: string,
): Promise<IBaseResponseModel<EBlogResponse>> => {
  return api.get(baseURL, API.GetSingleBySlug.url + "?slug=" + slug);
  //return res;
};

const create = async (
  data: FormData,
): Promise<IBaseResponseModel<EContentResponse>> => {
  return api.post(baseURL, API.Create.url, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  //return res;
};

const update = async (
  data: FormData,
): Promise<IBaseResponseModel<ESeoResponse>> => {
  return api.put(baseURL, API.Update.url, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  //return res;
};

const deletes = async (
  id: string,
): Promise<IBaseResponseModel<EBlogResponse>> => {
  return api.delete(baseURL, API.Delete.url + "?id=" + id);
  //return res;
};

const BlogFooterService = {
  userGetPage,
  adminGetPage,
  getSingle,
  getSingleBySlug,
  create,
  update,
  deletes,
};

export default BlogFooterService;
